"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerProperty = exports.Conjunction = exports.DestinationType = exports.Operator = void 0;
// Expression = operandA operator operandB
var Operator;
(function (Operator) {
    // Array
    Operator["IS"] = "is";
    Operator["IS_NOT"] = "is_not";
    // Number
    Operator["GT"] = "gt";
    Operator["GTE"] = "gte";
    Operator["LT"] = "lt";
    Operator["LTE"] = "lte";
    Operator["EQ"] = "eq";
    Operator["NEQ"] = "neq";
    // String
    Operator["EQUALS"] = "equals";
    Operator["NOT_EQUALS"] = "not_equals";
    Operator["CONTAINS"] = "contains";
    Operator["NOT_CONTAINS"] = "not_contains";
    Operator["STARTS_WITH"] = "starts_with";
    Operator["END_WITH"] = "end_with";
})(Operator = exports.Operator || (exports.Operator = {}));
var DestinationType;
(function (DestinationType) {
    DestinationType["QUESTION"] = "question";
    DestinationType["END_SCREEN"] = "end_screen";
    DestinationType["WELCOME_SCREEN"] = "welcome_screen";
})(DestinationType = exports.DestinationType || (exports.DestinationType = {}));
var Conjunction;
(function (Conjunction) {
    Conjunction["AND"] = "AND";
    Conjunction["OR"] = "OR";
})(Conjunction = exports.Conjunction || (exports.Conjunction = {}));
var AnswerProperty;
(function (AnswerProperty) {
    AnswerProperty["VALUE"] = "value";
    AnswerProperty["SELECTED_CHOICES"] = "selected_choices";
})(AnswerProperty = exports.AnswerProperty || (exports.AnswerProperty = {}));
//# sourceMappingURL=logicJumps.js.map